import Action from "./ScopeRequirementActions";
import Mutation from "./ScopeRequirementMutation";
import State from "./ScopeRequirementState";

export default {
  namespaced: true,
  state: State,
  mutations: Mutation,
  actions: Action,
};
